var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120.35999999999999,
    height: 137.52,
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("polyline", {
    id: "svg_1",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    points: "35.996039390563965,121.64617109298706 41.69604015350342,115.95616865158081 52.11603832244873,115.95616865158081 52.11603832244873,67.34616804122925 43.68603801727295,58.906165599823 21.086039543151855,58.906165599823 14.816039085388184,52.646167278289795 ",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_2",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    r: 4.09,
    cy: 124.89819,
    cx: 33.28503,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#88C424",
    id: "svg_3",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    y2: 74.50667,
    x2: 51.41503,
    y1: 74.50667,
    x1: 19.59463,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_4",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    r: 4.09,
    cy: 74.33617,
    cx: 13.65008,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_5",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    r: 4.09,
    cy: 49.11251,
    cx: 11.84935,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "svg_6",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    y2: 50.66364,
    x2: 32.13654,
    y1: 58.24364,
    x1: 39.70654,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_7",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    r: 4.09,
    cy: 46.98263,
    cx: 28.41149,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_8",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    r: 4.09,
    cy: 124.89819,
    cx: 61.02604,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#88C424",
    id: "svg_9",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    y2: 15.78223,
    x2: 61.02604,
    y1: 120.26667,
    x1: 61.02604,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_10",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    r: 4.09,
    cy: 10.4092,
    cx: 61.02604,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "svg_11",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    points: "85.9860372543335,119.81667280197144 80.28604030609131,114.12667036056519 69.86603832244873,114.12667036056519 69.86603832244873,65.51666975021362 75.89604091644287,59.48667097091675 92.92603969573975,59.48667097091675 ",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_12",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    r: 4.09,
    cy: 125.06869,
    cx: 88.86755,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "svg_13",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    y2: 74.49667,
    x2: 70.20604,
    y1: 74.49667,
    x1: 105.05604,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_14",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    r: 4.09,
    cy: 75.04819,
    cx: 109.95654,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_15",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    r: 4.09,
    cy: 60.06212,
    cx: 98.02806,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "svg_16",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    points: "61.35755443572998,56.25667142868042 68.38755321502686,49.23667097091675 104.167555809021,49.23667097091675 ",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_17",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    r: 4.09,
    cy: 49.19667,
    cx: 108.78654,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "svg_18",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    points: "74.24603939056396,48.98667097091675 84.04604244232178,39.1866717338562 94.09603786468506,39.1866717338562 ",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_19",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    r: 4.09,
    cy: 39.33718,
    cx: 98.29654,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "svg_20",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    points: "61.09603786468506,51.9366717338562 45.926039695739746,36.76666975021362 31.116040229797363,36.76666975021362 25.946040153503418,31.59667158126831 ",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_21",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    r: 4.09,
    cy: 27.44415,
    cx: 22.41402,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "svg_22",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    y2: 24.19667,
    x2: 76.05604,
    y1: 39.00667,
    x1: 61.24604,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_23",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    r: 4.09,
    cy: 20.76516,
    cx: 78.85553,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "svg_24",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    points: "42.336039543151855,21.766671657562256 46.98604106903076,26.41667127609253 56.246039390563965,26.41667127609253 61.02603816986084,31.206672191619873 ",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_25",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#88C424",
    fill: "none",
    r: 4.09,
    cy: 17.46314,
    cx: 38.80402,
    className: "cls-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.758afed6742b11c516a0de0f510dc4f9.svg";
export { ForwardRef as ReactComponent };